import React from 'react';
import {NavLink} from 'react-router-dom';
import {useSelector} from 'react-redux';
import './Sidebar.css';
import usePermission from '../custom/usePermission';
import { faktureBadge, badgeTekst } from '../custom/badgeFakture';
import { useTranslation } from 'react-i18next';

const Sidebar = ({ menuOpen, onClose }) => {
  const counter = useSelector(state => state.count)
  const counterInvoiceToCheck = useSelector(state => state.countInvoiceToCheck)
  const countAvansAlarm = useSelector(state => state.countAvansAlarm || 0)
  const ulazneZaMene = useSelector(state => state.ulazneZaMene || 0)
  const ulazneZaUnos = useSelector(state => state.ulazneZaUnos || 0)
  const unreadChat = useSelector(state => state.unreadChat || 0)
  const planNovi = useSelector(state => state.planNovi || 0)
  const planNeprocitani = useSelector(state => state.planNeprocitani || 0)
  const { can } = usePermission();
  const { t } = useTranslation();

  return (
    <>
      {menuOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <div className={`sidebar${menuOpen ? ' sidebar--open' : ''}`}>

          {can('TASKOVI', 'view') && (
          <NavLink className="button_sidebar sidebar-nav-item" to="/tabla_zaduzenja" onClick={onClose}>
            {t('nav.taskovi')}
            {planNovi > 0 && <span className="plan-sidebar-badge">{planNovi > 99 ? '99+' : planNovi}</span>}
            {/* Nepročitan komentar je druga vrsta hitnosti od broja zadataka —
                zato zasebna, crvena oznaka. Broj tu ne pomaže, važno je samo
                da te neko čeka. */}
            {planNeprocitani > 0 && (
              <span className="plan-sidebar-komentar" title="Imate nepročitan komentar na zadatku">
                <i className="pi pi-comment" />
              </span>
            )}
          </NavLink>
          )}
          {/* Beležnica — lična, vidljiva u sidebaru samo na mobile view (kao Taskovi) */}
          <NavLink className="button_sidebar sidebar-nav-item" to="/beleznica/unos" onClick={onClose}>
            {t('home.beleznica')}
          </NavLink>
          {can('FAKTURE', 'view') && (
          <NavLink className="button_sidebar sidebar-nav-item-rel" to="/fakture" onClick={onClose}>
            {t('nav.fakture')}
            {(() => {
              /* Zbir tabova Izlazne + Ulazne — isti računi kao na tabovima (custom/badgeFakture.js). */
              const total = faktureBadge(
                { countInvoiceToCheck: counterInvoiceToCheck, countAvansAlarm, ulazneZaMene, ulazneZaUnos },
                can('FAKTURE', 'edit'));
              if (total <= 0) return null;
              return <span className="sidebar-link-badge badge-blue">{badgeTekst(total)}</span>;
            })()}
          </NavLink>
          )}
          {can('TURE', 'view')         && <NavLink className="button_sidebar" to="/ture" onClick={onClose}>{t('nav.ture')}</NavLink>}
          {can('PLANER', 'view')       && <NavLink className="button_sidebar" to="/planerTura" onClick={onClose}>{t('nav.planer')}</NavLink>}
          {can('GPS', 'view')          && <NavLink className="button_sidebar" to="/gps" onClick={onClose}>{t('nav.gps')}</NavLink>}
          {can('MAGACIN', 'view')      && <NavLink className="button_sidebar" to="/magacin" onClick={onClose}>{t('nav.magacin')}</NavLink>}
          {can('SERVIS', 'view')       && <NavLink className="button_sidebar" to="/servis" onClick={onClose}>{t('nav.servis')}</NavLink>}
          {can('FINANSIJE', 'view')    && <NavLink className="button_sidebar" to="/finansije" onClick={onClose}>{t('nav.finansije')}</NavLink>}
          {can('MINISTARSTVO', 'view') && <NavLink className="button_sidebar" to="/ministarstvo" onClick={onClose}>{t('nav.ministarstvo')}</NavLink>}
          {can('KAZNE', 'view')        && <NavLink className="button_sidebar" to="/kazne" onClick={onClose}>{t('nav.kazne')}</NavLink>}
          <div className="button_sidebar">
            {can('PODRSKA', 'view') && (
              <NavLink to="/podrska" onClick={onClose}>{t('nav.podrska')}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.6 26.6 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.93.93 0 0 1-.765.935c-.845.147-2.34.346-4.235.346s-3.39-.2-4.235-.346A.93.93 0 0 1 3 9.219zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a25 25 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25 25 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135"/>
                  <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2zM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5"/>
                </svg>
              </NavLink>
            )}
            {can('VESTI', 'view')   && <NavLink to="/vesti" onClick={onClose}>{t('nav.vesti')}</NavLink>}
            {can('CHAT', 'view') && (
            <NavLink to="/chat" className="sidebar-bottom-rel" onClick={onClose}>
              {t('nav.chat')}
              {unreadChat > 0 && <span className="sidebar-link-badge badge-green">{unreadChat > 99 ? '99+' : unreadChat}</span>}
            </NavLink>
            )}
            {/* Podešavanja pristupa stoje ODVOJENO od zupčanika (zadatak 136):
                tamo su šifarnici firme i lična podešavanja, ovde se dodeljuju
                prava — dve različite stvari. Ko nema pravo, stavku ne vidi. */}
            {can('PRISTUP', 'view') && (
              <NavLink to="/pristup" onClick={onClose}>{t('nav.pristup')}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
                </svg>
              </NavLink>
            )}
            {/* Lična podešavanja (lozinka, jezik, tema, mobilna aplikacija) su se
                odselila u zaglavlje — „Moj profil" pored promene firme. Iza zupčanika
                ostaju samo šifarnici firme, pa ko nema pravo na Administraciju nema
                više šta da traži ovde i stavku ne vidi. */}
            {can('ADMINISTRACIJA', 'view') && (
            <NavLink to="/settings/configuration" onClick={onClose}>{t('nav.administracija')}<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-gear-fill" viewBox="0 0 16 16">
  <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
</svg></NavLink>
            )}
            <NavLink to="/info" className="sidebar-bottom-rel" onClick={onClose}>
              {t('nav.info')}
              {counter > 0 && <span className="sidebar-link-badge badge-red">{counter > 99 ? '99+' : counter}</span>}
            </NavLink>
          </div>
      </div>
    </>
  );
};

export default Sidebar;
